import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M22 20H11V13H22V20ZM9 20H2V13H9V20ZM22 11H2V4H22V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dashboard02"
);
